<template>
  <div class="box">
    <p
      style="
        margin: 10px 0;
        text-align: center;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">社区规范</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >一、总则</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >为维护良好的社区氛围，更好的保障用户合法权益，为用户提供绿色、健康的生态环境，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+根</span
      ><span style="font-family: 苹方-简; font-size: 16px">据现行法律法规</span
      ><span style="font-family: 苹方-简; font-size: 16px">制定</span
      ><span style="font-family: 苹方-简; font-size: 16px">《</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">社区</span
      ><span style="font-family: 苹方-简; font-size: 16px">规范</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">》（以下简称</span>“</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">本规范</span>”</span
      ><span style="font-family: 苹方-简; font-size: 16px">），由所有</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">用户共同遵守。</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >二、基本原则</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">.本</span
      ><span style="font-family: 苹方-简; font-size: 16px">规范</span
      ><span style="font-family: 苹方-简; font-size: 16px">适用于</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">所有用户</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >，包括教师用户与普通用户。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">2.</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >社区管理中心将根据现行法律法规及《</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+社区规范</span
      ><span style="font-family: 苹方-简; font-size: 16px">》中的条款对</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">的用户和发布在</span
      ><span style="font-family: 苹方-简; font-size: 16px">社区的</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >内容进行管理；采取的措施包括但不限于删除发布的内容、暂停或终止用户使用</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >的权利（在封禁期间的用户，产品部分功能将无法正常使用）。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">3</span
      ><span style="font-family: 苹方-简; font-size: 16px">.用户访问或使用</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >产品及网站，即视为同意接受本规范的全部内容。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px">三、</span></strong
      ><strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          ><span style="font-family: 苹方-简">爱艺术</span>+</span
        ></strong
      ><strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >社区管理规范和用户需遵守的行为准则</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">（一）</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">禁止发布内容</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >禁止发布的内容包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">.违法有害信息：</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >禁止发布违反法律法规，危害国家及社会安全的信息，包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >反对宪法所确定的基本原则</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >损害国家荣誉和利益</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >煽动民族仇恨、民族歧视，破坏民族团结</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >破坏国家宗教政策，宣扬邪教和封建迷信</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >散布谣言，扰乱社会秩序，破坏社会稳定</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >传播淫秽色情、赌博、暴力、凶杀、恐怖或者教唆犯罪</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >煽动非法活动、结社、游行、示威、聚众扰乱社会秩序</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >侮辱或者诽谤他人，侵害他人名誉，泄露他人隐私，侵害他人合法权益</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有法律、行政法规禁止的其他内容的信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">2</span
      ><span style="font-family: 苹方-简; font-size: 16px">.网络不良信息：</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >禁止制作、复制、发布、转载影响网络内容生态的内容信息，包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >使用夸张标题，内容与标题严重不符</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >炒作明星绯闻、丑闻、劣迹等娱乐八卦信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >不当评述自然灾害、重大事故等灾难</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >带有性暗示、性挑逗等易使人产生性联想的软色情信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >展现血腥、惊悚、残忍等致人身心不适的信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >煽动人群歧视、地域歧视等信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >宣扬低俗、庸俗、媚俗内容的信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >其他对网络生态造成不良影响的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">3</span
      ><span style="font-family: 苹方-简; font-size: 16px">.其他违规信息：</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >禁止发布影响用户体验，与社区氛围不符的内容，包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >短时间内重复发布与</span
      ><span style="font-family: 苹方-简; font-size: 16px">艺术</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >无关的鸡汤、段子、一连串无意义的文字、符号、字母、表情等内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >多次发表与帖子内容无关的灌水评论，内容相同或高度相似的帖子</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >发布含有钓鱼网站、木马、病毒网站链接及相关内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >发布含有潜在危险、可能窃取用户隐私的相关内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >发布含有威胁、易引起攻击性质的相关内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >发布无实质内容的极端负面情绪内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">（二）</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">抵制行为</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.冒充他人：禁止通过头像、姓名等各类自我说明，暗示自己与他人或机构相等同或有关联。冒充行为一经确定，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权对该内容进行操作并对其进行警告，情节严重者将封禁其账号。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">2</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.诈骗：禁止以虚构事实、发布招聘信息等方法，骗取他人财物。诈骗行为一经确定，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权删除所有相关内容，并永久封禁账号。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">3</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.骚扰：禁止通过私信或其他方式发送淫秽、侮辱、恐吓、广告推销或不良信息。</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >将通过接受用户举报的形式处理恶意骚扰行为。骚扰行为一经确认，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >将视情节严重程度对骚扰者进行警告或账号封禁处理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">4</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.制造谣言：禁止发布谣言内容挑唆对立、误导民众、引发恐慌，干扰公众认知、扰乱社会秩序，危害网民人身财产安全，损害企业个人利益、影响社会和谐稳定。制造谣言行为一经确认，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权删除所有相关内容，并视情节严重程度对其进行警告或账号封禁处理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >5.恶意举报：禁止随意举报不违规内容。</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >将视情节严重程度对恶意举报用户进行限制举报、警告或账号封禁处理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >6.以不正常方式（例如用机器或软件批量注册等）注册账户：禁止通过不正常渠道购买或注册账户来爬取数据或发布违规内容；一经发现核实后，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权关闭这些违规账户的登陆权限。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">7.以不正常行为</span
      ><span style="font-family: 苹方-简; font-size: 16px">获取粉丝</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >：禁止通过不正常渠道或不正常行为</span
      ><span style="font-family: 苹方-简; font-size: 16px">购买粉丝</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >。一经发现核实后，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px">有权</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >将粉丝数量恢复正常，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >并对该账户进行警告或账号封禁处理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >8.内容抄袭：禁止发布他人原创内容且不注明出处或标识转载。抄袭行为一经确认，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权删除所有相关内容，并视情节严重程度对其进行警告或账号封禁处理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">9</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.网络黑公关行为：抵制利用人工或技术手段，有偿为个人或企业删除负面信息，影响正常舆论传播秩序；刻意收集企业黑料或误导性信息撰写黑稿；炮制虚假信息，帮助企业抹黑竞争对手，混淆视听、迷惑民众；蹭热点、雇水军，恶意推广营销，制造虚假流量的行为</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">0.广告营销：</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >禁止发布以谋求钱财交易为目的广告推广内容，禁止发布影响用户体验、扰乱</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >社区规范的广告营销内容；包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">发布带有手机号、微信号、</span
        >QQ号、二维码等联系方式的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >在社区内以文字、视频、图片、二维码、站外链接的形式发帖、发评论、诱导转发分享活动</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >在他人没有明确需求的情况下，多次私信推销</span
      ><span style="font-family: 苹方-简; font-size: 16px">课程、商品或</span
      ><span style="font-family: 苹方-简; font-size: 16px">者服务</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >通过机器软件等非人力手段发布批量广告</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >通过错误的图文搭配进行广告宣传</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >（三）个人资料规则</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >鼓励用户使用个人的真实信息注册</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >，尤其是教师用户，宗旨是帮助您与其他艺术爱好者建立起良好的社区关系。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">对于违规内容，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权提示用户修改、删除相关信息，或者由管理员清空虚假信息。违规内容包括但不限于以下几点：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">.用户名</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >使用政府机构、媒体名称、企事业单位、公司、企业等作为用户名</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有广告推销、各种网站链接、联系方式等内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有无意义的英文字符、特殊符号等内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有低俗、辱骂、挑衅等不友好内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">使用他人姓名</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >映射或与官方人员姓名雷同并能引起混淆或纠纷的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >违反法律法规或不符合公序良俗的其他内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">2.头像</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >使用他人照片，包括但不限于党和国家领导人及各界社会名人的肖像</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简"
          >使用含有国家组织机构或其他组织机构的图片、徽章、</span
        >LOGO</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有人民币及相关等信息的图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有广告推销、各种链接、二维码、联系方式等信息的图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >带有人身攻击、谩骂、侮辱、挑衅、低俗用语等不文明内容的图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有国家组织机构或其他组织机构的图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >头部以下身体多处暴露的图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >违反法律法规的其他图片</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">3</span
      ><span style="font-family: 苹方-简; font-size: 16px">.职业信息</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">职业</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >信息不得虚假，包含：已离职未及时修改资料</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >、虚假机构的虚假头衔、</span
      ><span style="font-family: 苹方-简; font-size: 16px">故意冒充其他</span
      ><span style="font-family: 苹方-简; font-size: 16px">艺术家</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >或社会名人、虚夸</span
      ><span style="font-family: 苹方-简; font-size: 16px">职业</span
      ><span style="font-family: 苹方-简; font-size: 16px">或</span
      ><span style="font-family: 苹方-简; font-size: 16px">相关经历</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >带有人身攻击、谩骂、侮辱、挑衅、低俗用语等不文明内容的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有广告推销、各种链接、二维码、联系方式等信息的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">4</span
      ><span style="font-family: 苹方-简; font-size: 16px">.其他信息</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">性别不实</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >抄袭冒充他人信息</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >含有广告推销、各种链接、二维码、联系方式等信息的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >带有人身攻击、谩骂、侮辱、挑衅、低俗用语等不文明内容的内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >违反法律法规的其他内容</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">5</span
      ><span style="font-family: 苹方-简; font-size: 16px">.个人账户</span>
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >通过注册多个账户谋求不正当利益</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >买卖账户、将账户借与他人</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">其他扰乱</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >正常秩序或影响网站运营安全的行为</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >四、违规内容与行为处理流程</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">.</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >团队通过主动发现和接受用户举报两种方式发现违规行为。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">所有</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >用户都可对他人的</span
      ><span style="font-family: 苹方-简; font-size: 16px">动态及</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >私信进行举报。用户</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简"
          >可以直接进入动态详情，点击右上角的</span
        >“</span
      ><span style="font-family: 苹方-简; font-size: 16px">…</span
      ><span style="font-family: 苹方-简; font-size: 16px">”标识进行举报</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简"
          >；在私信界面，用户可点击右上角的</span
        >“…”标识进行举报。违规内容将视情节进行不同程度的处理。恶意举报不予受理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">2</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.违规处理的方式包括：</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >内容处理包括：扣除影响力、禁止发布帖子或评论、限制展现范围、删除等；</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        >账号处理包括：扣除影响力、禁言、限制展现范围、注销等；</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">3</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >.侵权举报：用户在</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >发布的内容仅表明其个人的立场和观点，并不代表</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >的立场和观点。如</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">个人和企业发现爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >上存在侵犯自身合法权益的内容，可以先尝试与发布者取得联系，通过沟通协商解决问题；如无法联系到发布者，或通过沟通无法解决问题，可再向</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >进行投诉。为了保证问题能够及时有效地处理，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >将要求举报人提交真实有效、完整清晰的证明材料，否则投诉将无法受理。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >五、申诉</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">如用户对</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >基于本规范做出的处理有异议，可到</span
      ><span style="font-family: 苹方-简; font-size: 16px">爱艺术</span
      ><span style="font-family: 苹方-简; font-size: 16px">+“我</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">的</span>—</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">在线客服</span
        >”中提供相关有效证据进行申诉，</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >客服团队将会对反馈进行复查。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <strong
        ><span style="font-family: 苹方-简; font-size: 16px"
          >六、附则</span
        ></strong
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px">1</span
      ><span style="font-family: 苹方-简; font-size: 16px">.使用</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >服务的过程中应当遵守当地相应的法律法规，并尊重当地的道德和风俗习惯。如果用户行为违反了当地法律法规或道德风俗，用户应当为此独立承担责任。用户应避免因使用本服务而使</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >卷入政治和公共事件，否则</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >有权暂停或终止其服务，并保留追究其法律责任的权利。</span
      >
    </p>
    <p
      style="
        margin: 10px 0;
        text-align: justify;
        font-family: 等线;
        font-size: 14px;
        white-space: normal;
        text-indent: 32px;
      "
    >
      <span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >团队可依照互联网发展的不同阶段，随着社区管理经验的不断丰富，出于维护</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        ><span style="font-family: 苹方-简">爱艺术</span>+</span
      ><span style="font-family: 苹方-简; font-size: 16px"
        >社区秩序的目的，不断完善本规范。完善后的规范公布后即发生效力。用户可定期查看本规范，以便获得最新信息。</span
      >
    </p>
    <p>
      <br />
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.box {
  padding: 16px;
}
</style>